import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ThanksComponent } from './thanks.component/thanks.component';

import {UnregisterComponent} from './unregister.component/unregister.component';

const routes: Routes = [
  {path: 'unregister/:email', component: UnregisterComponent},
  {path: 'thanks', component: ThanksComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class UnregisterRoutingModule { }
